import { type PrerenderUser } from '../PrerenderUser';
import { SharedABTesting } from '@prerender/prerender-shared/FE';

const SURVEY_RELEASE_DATE = new Date('2025-04-23T00:00:00Z');

export function hasAccessToSurvey(companyCreationDate: PrerenderUser['companyCreationDate']): boolean {
  return companyCreationDate >= SURVEY_RELEASE_DATE;
}

export function isUserTestingGroupA(id: PrerenderUser['id']): boolean {
  return SharedABTesting.getABTestingGroupForUser(id) === SharedABTesting.ABTestingGroup.GROUP_A;
}

export { useAnswersShortSurvey } from './useAnswersShortSurvey';
export { default as OnboardingSurvey } from './OnboardingSurvey';
export type { SurveyCompletion } from './OnboardingSurvey';
export { dismissSurvey, isSurveyDismissed } from './SurveyDismissal';
export * as OnboardingSurveyApi from './OnboardingSurveyApi';
export type { Answers } from './questions';
